import Layout from '../../components/common/pageLayout'
import CreateForm from '../../components/NCR/createForm'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import constant from '../../constant'
import { toast } from 'react-toastify'
import { v3_create_ncr } from '../../actions/v3/ncr'

const Index = (props) => {
    const location = useLocation();
    const { shipId, projectId, shipName } = location.state;
    console.log(projectId)
    const onSubmit = (model) => {
        v3_create_ncr({ ...model, shipId, projectId }).then((res) => {
            if (res.status) {
                toast.success(res.result.message)

                props.history.push({
                    pathname: constant.Authedcomponent.ncrDetail.url,
                    state: {
                        shipId,
                        shipName,
                        projectId,
                        ncrId: res.result.ncrId
                    }
                });
            }
            else {
                toast.error(res.error)
            }
        })
    }

    return (
        <Layout title={`NCR | ${shipName}`}>
            <CreateForm
                shipName={shipName}
                onSubmit={onSubmit}
                shipId={shipId}
                projectId={projectId}
            />
        </Layout>
    )
}

export default Index